import { cn } from '@core/lib/cn';

export interface PageGlyphProps {
  className?: string;
}

/**
 * A sheet of paper, as inline SVG.
 *
 * The kit's other decorative marks are emoji, which is the right call for
 * one-off glyphs — no icon dependency, no build step. This one is not, because
 * U+1F4C4 (📄) is missing from several Linux and older Android emoji fonts and
 * renders as a tofu box, and the two places it appears (the dropzone, and the
 * fallback when a page preview fails to load) are exactly the places a customer
 * looks to confirm they picked the right file.
 *
 * `currentColor` and no fixed size, so it inherits from whatever it sits in.
 * `aria-hidden` because it is always accompanied by real text.
 */
export function PageGlyph({ className }: PageGlyphProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={cn('h-8 w-8', className)}
    >
      <path d="M14 2.5H7A1.5 1.5 0 0 0 5.5 4v16A1.5 1.5 0 0 0 7 21.5h10a1.5 1.5 0 0 0 1.5-1.5V7Z" />
      <path d="M14 2.5V7h4.5" />
      <path d="M8.5 12.5h7M8.5 16h7M8.5 9h2.5" />
    </svg>
  );
}
